import React, { useState, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollProgress from './components/ScrollProgress';
import SearchModal from './components/SearchModal';
import FloatingCall from './components/FloatingCall';
import BackToTop from './components/BackToTop';
import ToastContainer from './components/Toast';
import SeoManager from './components/SeoManager';

// Pages are lazy-loaded so each route's code (and heavy libs like the PDF
// tools on the certificate pages) only downloads when that page is visited.
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Products = lazy(() => import('./pages/Products'));
const ProductDetail = lazy(() => import('./pages/ProductDetail'));
const Transportation = lazy(() => import('./pages/Transportation'));
const CertificateSearch = lazy(() => import('./pages/CertificateSearch'));
const GetQuote = lazy(() => import('./pages/GetQuote'));
const Contact = lazy(() => import('./pages/Contact'));
const Financing = lazy(() => import('./pages/Financing'));
const Careers = lazy(() => import('./pages/Careers'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const NotFound = lazy(() => import('./pages/NotFound'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));

function PageLoader() {
  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: 40, height: 40, border: '3px solid rgba(201,168,76,0.25)', borderTopColor: '#c9a84c', borderRadius: '50%', animation: 'ps-spin 0.8s linear infinite' }} />
      <style>{`@keyframes ps-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

export default function App() {
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <Router>
      <SeoManager />
      <ScrollToTop />
      <ScrollProgress />
      <Navbar onSearchOpen={() => setSearchOpen(true)} />
      {searchOpen && <SearchModal onClose={() => setSearchOpen(false)} />}
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:slug" element={<ProductDetail />} />
          <Route path="/transportation" element={<Transportation />} />
          <Route path="/certificate" element={<CertificateSearch />} />
          <Route path="/get-quote" element={<GetQuote />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/financing" element={<Financing />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/coi-upload" element={<AdminDashboard />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <Footer />
      <FloatingCall />
      <BackToTop />
      <ToastContainer />
    </Router>
  );
}